module.exports = __webpack_public_path__ + "img/bluedownload.a113f756.svg";